export class VoucherRequest {
    contractNumber: string;
    documentType: string;
    observations: string;
    totalAmount: number;

    constructor() {
        this.contractNumber = "";
        this.documentType = "";
        this.observations = "";
        this.totalAmount = 0;
    }
}